import axios from "axios";
import config from "../config";

// default
axios.defaults.baseURL = config.API_URL;

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url, params) => {
    return axios.get(url, params);
  };

  /**
   * post given data to url
   */

  create = async (url, data) => {
    try {
      const response = await axios.post(url, data);
      // console.log("from api_helper", response);
      return response;
    } catch (error) {
      // console.log("error from api_helper", error);
      let r_data = {
        error: error,
      };
      return r_data;
    }
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("access");
  if (!user) {
    return null;
  } else {
    return (user);
  }
};

// Function to get the user's role from localStorage
const getUserRole = () => {
  const authUser = localStorage.getItem("authUser");
  if (authUser) {
    try {
      const parsedAuthUser = JSON.parse(authUser);
      return parsedAuthUser?.role || null;
    } catch (error) {
      console.error("Error parsing authUser from localStorage:", error);
      return null;
    }
  }
  return null;
};

export { APIClient, setAuthorization, getLoggedinUser, getUserRole };
